import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_BOTON_LISTAR_ATRAS, } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { usePages } from "../../../utils/const/pages-const";
import { obtenerTodasLasUnidades } from "../../../api/gestion-dts/gestion";
import { obtenerPermisos, crearPermisos, modificarPermisos } from "../../../api/api-permisos";


export default function PermisosPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [row, setRow] = useState(null);
  const [titulo, setTitulo] = useState("");
  const [listaUnidades, setListaUnidades] = useState([]);
  const [unidadesSelected, setUnidadesSelected] = useState(null);
  const listaPages = usePages();
  const [permissions, setPermissions] = useState([]);
  const [permisosInfo, setPermisosInfo] = useState(null);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setRow(data.params);
        setTitulo(data.titulo);
      }
      // Initialize permissions with the pages structure
      // Deep clone to avoid mutating the original
      const pagesList = JSON.parse(JSON.stringify(listaPages));
      setPermissions(pagesList);
      const unidades = await obtenerTodasLasUnidades();
      // console.log('unidades');
      // console.log(unidades);
      setListaUnidades(unidades);

      const objEnviar = {
        idSubTipoUsuarioWeb: data.params.id,
      };
      const permisos = await obtenerPermisos(objEnviar);
      // console.log('permisos');
      // console.log(permisos);
      let permisosData = null;
      if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
        permisosData = permisos.data[0];
        setPermisosInfo(permisosData);
      }

      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  useEffect(() => {
    if (permisosInfo !== null) {
      updatePermissions();
    }
  }, [permisosInfo]);

  const updatePermissions = () => {
    try {
      // console.log('updatePermissions');
      if (permisosInfo === null) {
        console.log('updatePermissions: permisosInfo is null');
        return;
      }

      // console.log('permisosInfo');
      // console.log(permisosInfo);
      const unidadesHabilitadas = JSON.parse(permisosInfo.unidades);
      // console.log('unidadesHabilitadas');
      // console.log(unidadesHabilitadas);
      setUnidadesSelected(unidadesHabilitadas);
      const permisosHabilitados = JSON.parse(permisosInfo.permisos);
      // console.log('permisosHabilitados');
      // console.log(permisosHabilitados);
      // console.log('//////*****/////');
      // console.log('permissions');
      // console.log(permissions);

      // Sync checked states from permisosHabilitados to permissions
      syncCheckedStates(permisosHabilitados);
    }
    catch (err) {
      console.log('updatePermissions err');
      console.log(err);
    }
  };

  const syncCheckedStates = (permisosHabilitados) => {
    try {
      if (!permisosHabilitados || !Array.isArray(permisosHabilitados)) {
        console.log('syncCheckedStates: permisosHabilitados is not a valid array');
        return;
      }

      setPermissions(prevPermissions => {
        // Check if permissions are initialized
        if (!prevPermissions || !Array.isArray(prevPermissions) || prevPermissions.length === 0) {
          console.log('syncCheckedStates: permissions not initialized yet');
          return prevPermissions;
        }

        const updatedPermissions = JSON.parse(JSON.stringify(prevPermissions));

        // Iterate through each page in permisosHabilitados
        permisosHabilitados.forEach((habilitadoPage, pageIndex) => {
          // Find the corresponding page in permissions by value
          const permissionPage = updatedPermissions.find(
            page => page.value === habilitadoPage.value
          );

          if (!permissionPage) {
            return;
          }

          // Sync page-level checked attribute (independent of actions)
          if (habilitadoPage.hasOwnProperty('checked')) {
            permissionPage.checked = habilitadoPage.checked === true;
          }

          // Sync individual action states (independent of page-level checked)
          if (habilitadoPage.acciones && permissionPage.acciones) {
            // Iterate through acciones in the enabled page
            habilitadoPage.acciones.forEach((habilitadoAccion, actionIndex) => {
              if (!permissionPage.acciones[actionIndex]) {
                return;
              }

              // Check if it's a nested structure (object with keys like btn_buscar, btn_ver, etc.)
              if (typeof habilitadoAccion === 'object' &&
                habilitadoAccion !== null &&
                !habilitadoAccion.hasOwnProperty('label') &&
                !habilitadoAccion.hasOwnProperty('value')) {
                // This is the nested structure case
                Object.keys(habilitadoAccion).forEach((key) => {
                  const habilitadoNested = habilitadoAccion[key];
                  const permissionNested = permissionPage.acciones[actionIndex][key];

                  if (habilitadoNested &&
                    permissionNested &&
                    habilitadoNested.hasOwnProperty('checked')) {
                    // Update the checked state
                    permissionNested.checked = habilitadoNested.checked === true;
                  }
                });
              } else {
                // This is the simple array structure case
                if (habilitadoAccion &&
                  habilitadoAccion.hasOwnProperty('checked') &&
                  permissionPage.acciones[actionIndex]) {
                  // Update the checked state
                  permissionPage.acciones[actionIndex].checked = habilitadoAccion.checked === true;
                }
              }
            });
          }
        });

        return updatedPermissions;
      });
    } catch (err) {
      console.log('syncCheckedStates err');
      console.log(err);
    }
  };

  // const handleInputChange = (event) => {
  //   // console.log('handleInputChange');
  //   const { name, value } = event.target;
  //   // console.log(name);
  //   // console.log(value);
  //   setRow({ ...row, [name]: value });
  // };

  const handleCancelClick = () => {
    history.goBack();
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('row');
    // console.log(row);
    // console.log('permissions');
    // console.log(permissions);
    let objEnviar = {};
    objEnviar.idSubTipoUsuarioWeb = row.id;
    objEnviar.unidades = unidadesSelected !== null ? unidadesSelected : [];
    objEnviar.permisos = permissions;
    // console.log('objEnviar');
    // console.log(objEnviar);
    // return;
    if (permisosInfo === null) {
      // console.log('crear correo');
      const creado = await crearPermisos(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (creado === true) {
        alert(t('alert_se_creo_correctamente'));
        handleCancelClick();
      }
      if (creado === false) {
        alert(t('alert_no_se_pudo_crear'));
      }
    }
    if (permisosInfo !== null) {
      // console.log('actualizar permisos');
      // console.log(permisosInfo);
      objEnviar.id = permisosInfo.id;
      const modificado = await modificarPermisos(objEnviar);
      // console.log('modificado');
      // console.log(modificado);
      if (modificado === true) {
        alert(t('alert_se_modifico_correctamente'));
        handleCancelClick();
      }
      if (modificado === false) {
        alert(t('alert_no_se_pudo_modificar') + ' ' + modificado.message);
      }
    }
  };

  const handlePermissionChange = (pageIndex, actionIndex, checked, isNested = false, nestedKey = null) => {
    setPermissions(prevPermissions => {
      const updated = JSON.parse(JSON.stringify(prevPermissions));
      const page = updated[pageIndex];

      if (!page) return updated;

      if (isNested && nestedKey) {
        // Handle nested structure (like respuestas checklist)
        if (page.acciones[actionIndex][nestedKey]) {
          page.acciones[actionIndex][nestedKey].checked = checked;
        }
      } else {
        // Handle simple array structure
        if (page.acciones[actionIndex]) {
          page.acciones[actionIndex].checked = checked;
        }
      }

      // Note: page-level checked is independent of actions
      // It represents page access, not action permissions
      // Individual actions can be checked/unchecked independently

      return updated;
    });
  };

  const handlePageCheckedChange = (pageIndex, checked) => {
    setPermissions(prevPermissions => {
      const updated = JSON.parse(JSON.stringify(prevPermissions));
      const page = updated[pageIndex];

      if (!page) return updated;

      // Update page-level checked
      page.checked = checked;

      // Update all acciones to match the page-level checked state
      if (page.acciones && Array.isArray(page.acciones)) {
        page.acciones.forEach((accion) => {
          // Check if it's a nested structure
          if (typeof accion === 'object' &&
            accion !== null &&
            !accion.hasOwnProperty('label') &&
            !accion.hasOwnProperty('value')) {
            // This is the nested structure case - update all nested actions
            Object.keys(accion).forEach((key) => {
              if (accion[key] && typeof accion[key] === 'object') {
                accion[key].checked = checked;
              }
            });
          } else {
            // This is the simple array structure case
            if (accion && typeof accion === 'object') {
              accion.checked = checked;
            }
          }
        });
      }

      return updated;
    });
  };

  const renderAcciones = (page, pageIndex) => {
    try {
      if (!page.acciones || page.acciones.length === 0) {
        return (
          <div className="text-gray-500 text-sm italic p-2">
            {t('label_sin_acciones_disponibles') || 'No actions available'}
          </div>
        );
      }

      return (
        <div className="space-y-2">
          {page.acciones.map((accion, actionIndex) => {
            // Check if this is a nested structure (object with keys like btn_buscar, btn_ver, etc.)
            if (typeof accion === 'object' && accion !== null && !accion.hasOwnProperty('label')) {
              // This is the nested structure case
              return (
                <div key={actionIndex} className="space-y-2">
                  {Object.keys(accion).map((key) => {
                    const nestedAction = accion[key];
                    if (nestedAction && nestedAction.label) {
                      // Show the action's own checked state (independent of page-level checked)
                      const isChecked = nestedAction.checked || false;
                      return (
                        <div
                          key={key}
                          className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded transition-colors"
                        >
                          <input
                            type="checkbox"
                            id={`permission-${pageIndex}-${actionIndex}-${key}`}
                            checked={isChecked}
                            onChange={(e) =>
                              handlePermissionChange(pageIndex, actionIndex, e.target.checked, true, key)
                            }
                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
                          />
                          <label
                            htmlFor={`permission-${pageIndex}-${actionIndex}-${key}`}
                            className="text-sm text-gray-700 cursor-pointer flex-1"
                          >
                            {nestedAction.label}
                          </label>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              );
            } else {
              // This is the simple array structure case
              // Show the action's own checked state (independent of page-level checked)
              const isChecked = accion.checked || false;
              return (
                <div
                  key={actionIndex}
                  className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded transition-colors"
                >
                  <input
                    type="checkbox"
                    id={`permission-${pageIndex}-${actionIndex}`}
                    checked={isChecked}
                    onChange={(e) =>
                      handlePermissionChange(pageIndex, actionIndex, e.target.checked, false, null)
                    }
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
                  />
                  <label
                    htmlFor={`permission-${pageIndex}-${actionIndex}`}
                    className="text-sm text-gray-700 cursor-pointer flex-1"
                  >
                    {accion.label}
                  </label>
                </div>
              );
            }
          })}
        </div>
      );
    } catch (err) {
      console.log('renderAcciones err');
      console.log(err);
      return <div className="text-red-500 text-sm">Error rendering actions</div>;
    }
  };

  const renderPermissions = () => {
    try {

      return permissions.map((page, pageIndex) => (
        <div
          key={page.value || pageIndex}
          className="col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3"
        >
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow p-4 h-full">
            <div className="flex items-center space-x-2 mb-3 pb-2 border-b border-gray-200">
              <input
                type="checkbox"
                id={`page-permission-${pageIndex}`}
                checked={page.checked || false}
                onChange={(e) => handlePageCheckedChange(pageIndex, e.target.checked)}
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
              />
              <h3 className="text-lg font-semibold text-gray-800 flex-1 cursor-pointer"
                onClick={() => handlePageCheckedChange(pageIndex, !(page.checked || false))}>
                {page.label}
              </h3>
            </div>
            <div className="max-h-64 overflow-y-auto">
              {renderAcciones(page, pageIndex)}
            </div>
          </div>
        </div>
      ));
    } catch (err) {
      console.log('renderPermissions err');
      console.log(err);
      return (
        <div className="col-span-12 text-center py-8 text-red-500">
          Error rendering permissions: {err.message}
        </div>
      );
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (cargandoPage === false && row === null) {
        return (
          <div>
            <label> Sin data</label>
          </div>
        );
      }
      return (
        <div className="min-h-screen m-4">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6">
              <h2 className="text-2xl font-bold">{titulo}</h2>
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6 flex justify-end">
              <button type="button" className={ESTILO_BOTON_LISTAR_ATRAS} onClick={handleCancelClick}>
                {t('btn_atras')}
              </button>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
              <label>{t('label_seleccione_unidad')}</label>
              <Select
                options={listaUnidades}
                value={unidadesSelected}
                onChange={(e) => {
                  setUnidadesSelected(e);
                }}
                isClearable={true}
                isSearchable={true}
                isMulti={true}
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4 mt-4">
            {renderPermissions()}
          </div>
          <div className="grid grid-cols-12 gap-4 mt-6">
            <div className="col-span-12 flex justify-end space-x-3">
              <button
                type="button"
                className={ESTILO_BOTON_GENERAL_CANCELAR}
                onClick={handleCancelClick}
              >
                {t('btn_cancelar')}
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_GENERAL_ACEPTAR}
                onClick={handleSaveClick}
              >
                {t('btn_guardar')}
              </button>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.log('SubTipoUsuarioWeb render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
